import PositionState from "src/Types/states/PositionState";

const positionInitialState:PositionState = [];

export default positionInitialState;
